import http from "../http-common"

export const getPendingCertificates = () => { 
    return  http.get("/certificate/pendingCertificates")   
}

export const updatePendingCertificates = (id) => {
  return http.put(`/certificate/verifyCertificate/${id}`) 
}